var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nine"},[_c('img',{staticClass:"about",attrs:{"src":"https://gw-resources.uhan.net.cn/about.png","alt":""}})])
}]

export { render, staticRenderFns }